import { SeeqNames } from '@/main/app.constants.seeqnames';

export const defaultContamination = 0.1;
export const minNumEstimators = 1;
export const maxNumEstimators = 200;
export const minContamination = 0;
export const maxContamination = 0.5;

const packageName = SeeqNames.MlService.IsolationForest.Connection.UdfPackage;
const udfName = SeeqNames.MlService.IsolationForest.Connection.UdfName;
export const UDF_NAME = `${packageName}_${udfName}`;

export const DEFAULT_NUM_ESTIMATORS = 10;
export const DEFAULT_CONTAMINATION = 0.1;
export const DEFAULT_BOOTSTRAP = false;

export const INPUT_NAMES = {
  numEstimatorsInput: 'numEstimatorsInput',
  contaminationInput: 'contaminationInput',
  randomStateInput: 'randomStateInput',
  bootstrapInput: 'bootstrapInput',
  startTimeInput: 'startTimeInput',
  endTimeInput: 'endTimeInput',
  signalInput: 'signalInput',
  restrictOutputToConditionInput: 'restrictOutputToConditionInput',
  trainWithinConditionInput: 'trainWithinConditionInput',
  mergeCapsuleDurationInput: 'mergeCapsuleDurationInput',
  minCapsuleDurationInput: 'minCapsuleDurationInput',
};

export const OUTPUT_TRANSLATION_KEYS: Record<string, Record<string, string>> = {
  anomalyOutput: {
    label: 'INVESTIGATE_TOOLS.ISOLATION_FOREST_V2.OUTPUTS.ANOMALY_CONDITION',
    icon: 'fc fc-capsule-set',
  },
  scoresSignalOutput: {
    label: 'INVESTIGATE_TOOLS.ISOLATION_FOREST_V2.OUTPUTS.ANOMALY_SCORE_SIGNAL',
    icon: 'fc fc-series',
  },
  modelInputPropertiesOutput: {
    label: 'INVESTIGATE_TOOLS.ISOLATION_FOREST_V2.OUTPUTS.MODEL_INPUT_PROPERTIES',
    icon: 'fc fc-scalar',
  },
  trainingWindowConditionOutput: {
    label: 'INVESTIGATE_TOOLS.ISOLATION_FOREST_V2.OUTPUTS.TRAINING_WINDOW_CONDITION',
    icon: 'fc fc-capsule-set',
  },
};

export const DEFAULT_OUTPUTS: string[] = ['anomalyOutput', 'scoresSignalOutput'];

export const MODEL_NAME = SeeqNames.ModelNames.IsolationForest;
